const VIDEO_TYPE = {
	YOUTUBE: "YouTube",
};

export default VIDEO_TYPE;
export { VIDEO_TYPE };
